var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerceivedFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9F2;}\r\n\t.st1{fill:#9ED4FF;}\r\n\t.st2{fill:#00FFFF;}\r\n\t.st3{fill:#00FF00;}\r\n\t.st4{fill:#FFFF00;}\r\n\t.st5{fill:#FFAA00;}\r\n\t.st6{fill:#FF0000;}\r\n\t.st7{fill:#646464;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M256.1,2c140.3,0,254,113.7,254,254c0,140.2-113.6,253.9-254,253.9C115.8,510,2,396.3,2,256.1 C2,115.8,115.8,2,256.1,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M323.2,295.3h-27.7v49.2H265v-49.2h-76.4v-18.7l79.9-109.9h27v102.4h27.7V295.3z M265,230.5l2.3-21.2h-1 l-8.6,18.1l-26.2,34.1l-12.6,9.6l16.1-2h30V230.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerceivedFour);
export default __webpack_public_path__ + "static/media/PerceivedFour.6f050519fb4d60e7a286e209afcb0fb9.svg";
export { ForwardRef as ReactComponent };